/**
 * Upload a File or Blob to Cloudinary via the PubSilo upload endpoint.
 * Returns the secure Cloudinary URL on success, throws on failure.
 */
export async function uploadImage(file, token) {
  const formData = new FormData();
  formData.append('image', file);

  const res = await fetch('/api/upload/image', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Image upload failed.');
  }

  const { url } = await res.json();
  return url;
}
